/* Progressive image reveal. A missing/failed alternate never hides the jar. */
(function () {
  'use strict';
  function ready(img) {
    if (!img.matches('[data-card-alternate]') || !img.complete || !img.naturalWidth) return;
    var card = img.closest('.card');
    if (card) card.classList.add('card--image-ready');
  }
  function scan(root) {
    root.querySelectorAll('[data-card-alternate]').forEach(ready);
  }
  document.addEventListener('load', function (event) {
    if (event.target instanceof HTMLImageElement) ready(event.target);
  }, true);
  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-card-switch]');
    if (!button) return;
    var card = button.closest('.card');
    if (!card || !card.classList.contains('card--image-ready')) return;
    var shown = button.getAttribute('aria-pressed') !== 'true';
    card.classList.toggle('card--alternate-shown', shown);
    button.setAttribute('aria-pressed', String(shown));
    button.setAttribute('aria-label', shown
      ? window.Nutritia.t('card_first_label', 'View 2: first image of {title}', {title: button.dataset.productTitle})
      : window.Nutritia.t('card_alt_label', 'View 2: alternate image of {title}', {title: button.dataset.productTitle}));
    button.querySelector('span').textContent = shown ? window.Nutritia.t('view_1', 'View 1') : window.Nutritia.t('view_2', 'View 2');
  });
  document.addEventListener('shopify:section:load', function (event) { scan(event.target); });
  document.addEventListener('nutritia:cards-updated', function () { scan(document); });
  scan(document);
})();
